type IconSize = { width: number; height: number };

export function getDotIconSize({ isMobile, zoom }: { isMobile: boolean; zoom: number }): IconSize {
  if (isMobile) {
    if (zoom >= 15) {
      return { width: 12, height: 12 };
    } else if (zoom >= 13) {
      return { width: 8, height: 8 };
    } else {
      return { width: 5, height: 5 };
    }
  } else {
    if (zoom > 14) {
      return { width: 14, height: 14 };
    } else if (zoom >= 13) {
      return { width: 10, height: 10 };
    } else if (zoom >= 11) {
      return { width: 7, height: 7 };
    } else {
      return { width: 5, height: 5 };
    }
  }
}
